module.exports = __webpack_public_path__ + "static/media/term-hide.47d43347.png";